import { Link as RouterLink } from 'react-router-dom'
import { BarChart, Settings } from '@mui/icons-material'
import {
  AppBar,
  IconButton,
  Link,
  Toolbar,
  Stack,
  useTheme,
  Tooltip,
} from '@mui/material'
import Logo from '@/assets/Logo'
import useIsSuperUser from '@/services/hooks/useIsSuperUser'
import BreadcrumbPortal from '@/components/breadcrumbs/BreadcrumbPortal'
import RootOrganizationPicker from '@/components/organizations/RootOrganizationPicker'
import TopBarPortal from '@/components/top-bar-portal/TopBarPortal'
import DemoModeInfo from './DemoModeInfo'
import HelpMenu from './HelpMenu'
import ProfileMenu from './ProfileMenu'
import SuperUserMenu from './SuperUserMenu'

export default function AppTopBar() {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const isSuperUser = useIsSuperUser()

  return (
    <AppBar
      position="static"
      elevation={isDark ? 1 : 0}
      sx={{
        zIndex: theme.zIndex.drawer + 2,
        borderBottom: isDark ? 'none' : `1px solid ${theme.palette.divider}`,
        background: isDark ? undefined : theme.palette.background.paper,
      }}
    >
      <Toolbar
        component={Stack}
        direction="row"
        disableGutters
        justifyContent="space-between"
        variant="dense"
        sx={{ py: '2px' }}
      >
        <Stack direction="row" alignItems="flex-end">
          <Link ml={1} mb={2.5} to="/" component={RouterLink}>
            <Logo />
          </Link>
          <div style={{ alignSelf: 'center' }}>
            <BreadcrumbPortal />
          </div>
        </Stack>
        <DemoModeInfo />

        <Stack direction="row" alignItems="center">
          <RootOrganizationPicker />
          <Tooltip title="Document Metrics">
            <IconButton
              component={RouterLink}
              to="/metrics/documents"
              size="small"
            >
              <BarChart />
            </IconButton>
          </Tooltip>
          <Tooltip title="Global Settings">
            <IconButton component={RouterLink} to="settings" size="small">
              <Settings />
            </IconButton>
          </Tooltip>
          <HelpMenu />
          <ProfileMenu />
          {isSuperUser && <SuperUserMenu />}
        </Stack>
      </Toolbar>
      <TopBarPortal />
      <TopBarPortal isPrimary={false} />
    </AppBar>
  )
}
